import { render, staticRenderFns } from "./TutorConfirmTraffic.vue?vue&type=template&id=67f183fa"
import script from "./TutorConfirmTraffic.vue?vue&type=script&lang=js"
export * from "./TutorConfirmTraffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports